// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__tWLdw","description":"style_description__btssh"};